import { futureValueSIP, monthlySWPForLumpsum } from "../../engine/calculations";
import { currencyAxis, yearsAxis } from "./reckonerAxes";

const config = {
  key: "rr-sip-swp",
  title: "SIP – SWP Ready Reckoner",
  category: "Ready Reckoners",
  description: "Build a corpus via SIP, then see the sustainable monthly income it can pay out afterwards.",
  reckoner: true,
  rowAxis: currencyAxis("Monthly SIP", [5_000, 10_000, 15_000, 20_000, 25_000]),
  colAxis: yearsAxis("Years Invested", [10, 15, 20, 25, 30]),
  extraFields: [
    { key: "buildReturn", label: "Return while building the corpus", type: "percent", default: 12, min: 1, max: 30, assumptionKey: "equityReturn" },
    { key: "withdrawReturn", label: "Return during withdrawal", type: "percent", default: 7, min: 1, max: 20, assumptionKey: "debtReturn" },
    { key: "withdrawYears", label: "Years the income should last", type: "number", default: 20, min: 1, max: 50 },
  ],
  computeCell(monthly, buildYears, extra) {
    const buildReturn = (Number(extra.buildReturn) || 0) / 100;
    const withdrawReturn = (Number(extra.withdrawReturn) || 0) / 100;
    const withdrawYears = Number(extra.withdrawYears) || 0;
    const corpus = futureValueSIP(monthly, buildReturn, buildYears * 12);
    return monthlySWPForLumpsum(corpus, withdrawReturn, withdrawYears);
  },
};

export default config;
